import styled from "styled-components";

export const RadioWithInputWrapperDiv = styled.div`
    display: flex;
    flex-direction: column;

    .MuiFormControlLabel-root:hover {
        background-color: transparent;
    }
`;
